import React from "react"
import LocaleSelect from "@/components/common/LocaleSelect"
import Socials from "@/components/common/Socials"
import styled from "styled-components"
import { BREAKPOINTS } from "@/styles/themeSettings"
import { getCssSizeValue } from "@/utils/utils"

const Locale = styled(LocaleSelect)`
	margin-top: ${getCssSizeValue(24, BREAKPOINTS.TABLET)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-top: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
		margin-bottom: ${getCssSizeValue(8, BREAKPOINTS.DESKTOP)};
	}
`
const Info = () => {
	return (
		<>
			<Socials />
			<Locale className="locale-select" />
		</>
	)
}

export default Info
